import { render } from "./ContentFooter.vue?vue&type=template&id=d38eb7f8&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"

import "./ContentFooter.vue?vue&type=style&index=0&id=d38eb7f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38eb7f8"]])

export default __exports__